<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      :endpoint="`modems/broadcasts/${this.id}`"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
    />

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
      >
        <el-table-column type="expand">
          <template slot-scope="{row}">
            <div class="modem-command-details-expand">
              <modem-command-details :command="row"></modem-command-details>
            </div>
          </template>
        </el-table-column>
        <table-column-date/>
        <el-table-column
          prop="type"
          label="Тип"
          width="150"
          align="center"
        />
        <el-table-column
          prop="state"
          label="Статус"
          width="150"
          align="center">
          <template slot-scope="{row}">
            {{ row.state }}
            <div class="text-danger" v-if="row.error_code">Ошибка {{ row.error_code }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="data_result" label="Ответ">
          <template slot-scope="{row}">
            <pre v-if="row.data_result" class="modem-command-data-result-preview m-0"
            >{{ row.data_result.trim() }}</pre>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      id: {},
    },
    data () {
      return {
        data: {},
        loading: false,
        hasMore: true,
      }
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .modem-command-data-result-preview {
    @include text-overflow-lines(2);
    position: relative;
    &:after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: .6em;
      pointer-events: none;
      @include gradient-y(rgba(#fff, 0), rgba(#fff, .3));
    }
  }
  .modem-command-details-expand .modem-command-data-result {
    max-height: 29.5 * $line-height-base * 1em;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/modems/index/broadcasts/_id.vue